'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Panel = require('@narvar/nth-block-panel');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Button = require('@narvar/nth-block-button');
var language_en_US = require('../../../consts/language_en_US.js');
var index = require('../../../components/Language/index.js');
var Spinner = require('../../../components/Spinner/Spinner.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/SelectList/SelectList.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
var SwatchesList = require('../../../components/SwatchesList/SwatchesList.js');
var index$1 = require('../../../components/TextLink/index.js');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var Sparsem = require('../../../utils/Sparsem.js');
var ReturnReasonsExchange_module = require('./ReturnReasonsExchange.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const tempLanguageKeys = {
  returnsReasonsExchangeTitle: language_en_US["default"].returnsReasonsExchangeTitle,
  returnsReasonsExchangeUpsellTitle: language_en_US["default"].returnsReasonsExchangeUpsellTitle,
  returnsReasonsExchangeUpsellNoThanks: language_en_US["default"].returnsReasonsExchangeUpsellNoThanks,
  returnsActionsNext: language_en_US["default"].returnsActionsNext
};
const findBestMatch = (variants, variantInfo) => {
  const entries = Object.entries(variantInfo ?? {});
  return entries.length ? variants.find(variant => entries.every(_ref => {
    var _variant$variantInfo, _variant$variantInfo$;
    let [key, optInfo] = _ref;
    return ((_variant$variantInfo = variant.variantInfo) === null || _variant$variantInfo === void 0 ? void 0 : (_variant$variantInfo$ = _variant$variantInfo[key]) === null || _variant$variantInfo$ === void 0 ? void 0 : _variant$variantInfo$.value) === (optInfo === null || optInfo === void 0 ? void 0 : optInfo.value);
  })) : undefined;
};
const findExactMatch = (variants, variantInfo) => {
  const bestMatch = findBestMatch(variants, variantInfo);
  if (!bestMatch) return undefined;
  const same = Object.entries(bestMatch.variantInfo ?? {}).every(_ref2 => {
    var _variantInfo$key;
    let [key, optInfo] = _ref2;
    return (variantInfo === null || variantInfo === void 0 ? void 0 : (_variantInfo$key = variantInfo[key]) === null || _variantInfo$key === void 0 ? void 0 : _variantInfo$key.value) === optInfo.value;
  });
  return same ? bestMatch : undefined;
};
const positionSorterFactory = defaultValue => (a, b) => (a.position ?? defaultValue) - (b.position ?? defaultValue);
const sparsemFactory = (exchangeVariants, exchangeOptions) => {
  const sparsem = new Sparsem["default"]();
  // Construct available options' values. Noted that it may not be start from 0
  const optionsSize = Math.max(...exchangeOptions.map(o => o.position ?? -1), -1) + 1 || exchangeOptions.length;
  const opts = new Array(optionsSize).fill([]);
  exchangeOptions.forEach((option, i) => {
    const pos = option.position ?? i;
    opts[pos] = option.values.map(v => v.value);
  });
  // Construct available exchange variants and corresponding option values
  const variants = exchangeVariants.filter(variant => variant.available).map(variant => {
    const values = Object.values(variant.variantInfo ?? {}).filter(Boolean);
    const ret = new Array(opts.length).fill(undefined);
    values.forEach((info, i) => {
      ret[info.optionPosition ?? i] = info.value;
    });
    return ret;
  });
  sparsem.setArr(variants, opts);
  return sparsem;
};
const ReturnReasonsExchange = _ref3 => {
  let {
    orderItem,
    upsell,
    shopNow,
    exchangeOptions = [],
    exchangeVariants = [],
    exchangeSelections,
    loading,
    hideSubmit,
    onSkip,
    onChange,
    onSubmit
  } = _ref3;
  const MAIN_EXCHANGE_OPTION_ID = 'PRODUCT';
  const {
    returnsReasonsExchangeTitle,
    returnsReasonsExchangeUpsellTitle,
    returnsReasonsExchangeUpsellNoThanks,
    returnsActionsNext
  } = tempLanguageKeys;
  const sortedExchangeOptions = React.useMemo(() => exchangeOptions.sort(positionSorterFactory(exchangeOptions.length)).map(option => ({
    ...option,
    values: option.values.sort(positionSorterFactory(option.values.length))
  })), [exchangeOptions]);
  const sparsem = React.useMemo(() => sparsemFactory(exchangeVariants, sortedExchangeOptions), [exchangeVariants, sortedExchangeOptions]);
  const handleChangeFactory = React.useCallback(opt => value => {
    // reset (unselect) other options when user clicks on a product
    // (i.e., filter out all fields that are not 'product')
    // toUpperCase() added because this field name is not standardized
    const filteredKeys = Object.entries(exchangeSelections || {}).find(_ref4 => {
      let [key] = _ref4;
      return key.toUpperCase() === MAIN_EXCHANGE_OPTION_ID;
    }) || [];
    const filteredObj = filteredKeys.length ? Object.fromEntries([filteredKeys]) : {};
    const variantInfo = opt.id.toUpperCase() === MAIN_EXCHANGE_OPTION_ID ? filteredObj : {
      ...exchangeSelections
    };
    const selected = opt.values.find(v => v.value === value);
    if (selected) {
      variantInfo[opt.id] = {
        optionId: opt.id,
        optionName: opt.name,
        optionPosition: opt.position,
        ...selected
      };
    } else {
      delete variantInfo[opt.id];
    }
    const event = {
      exchangeTo: findExactMatch(exchangeVariants, variantInfo),
      variantInfo: variantInfo
    };
    if (onChange) onChange(event);
  }, [exchangeSelections, exchangeVariants, onChange]);
  const exactMatch = React.useMemo(() => findExactMatch(exchangeVariants, exchangeSelections), [exchangeVariants, exchangeSelections]);
  const swatches = React.useMemo(() => {
    const swatchesOptions = sortedExchangeOptions.map((opt, i) => {
      let values = Object.values(exchangeSelections ?? {});
      values = values.map((info, j) => ({
        ...info,
        position: info.optionPosition ?? j
      })).sort(positionSorterFactory(values.length));
      const searchTokens = new Array(sparsem.num).fill(undefined);
      values.forEach((v, j) => searchTokens[(v === null || v === void 0 ? void 0 : v.position) ?? j] = v.value);
      searchTokens[opt.position ?? i] = null;
      const availability = sparsem.search(searchTokens);
      const swatchOption = {
        ...opt,
        options: opt.values.map(v => {
          const bestMatchOfCurrentOption = findBestMatch(exchangeVariants, {
            [opt.id]: v
          });
          return {
            value: v.value,
            label: v.name ?? v.value,
            color: v.color,
            imageUrl: v.imageUrl ?? (bestMatchOfCurrentOption === null || bestMatchOfCurrentOption === void 0 ? void 0 : bestMatchOfCurrentOption.imageUrl),
            grayedOut: availability[v.value] !== Sparsem.IN_STOCK
          };
        })
      };
      return swatchOption;
    });
    return swatchesOptions;
  }, [sparsem, sortedExchangeOptions, exchangeVariants, exchangeSelections]);

  // auto select the first available "product" option during initialization
  React.useEffect(() => {
    var _swatches$;
    if (upsell) return;
    if (exchangeSelections) return;
    const key = (_swatches$ = swatches[0]) === null || _swatches$ === void 0 ? void 0 : _swatches$.id;
    const swatch = /^product$/i.test(key) ? swatches[0] : undefined;
    if (!swatch) return;
    const defaultSelection = swatch.options.find(opt => !opt.disabled);
    if (defaultSelection) {
      handleChangeFactory(swatch)(defaultSelection.value);
    }
  }, [upsell, swatches, exchangeSelections, handleChangeFactory]);
  const noThanks = upsell && Object.values(exchangeSelections ?? {}).filter(d => d).length === 0;
  const unavailable = !loading && exchangeOptions.length === 0 && exchangeVariants.length === 0;
  const handleShopNow = () => {
    const event = exchangeVariants.find(v => v.variantId === orderItem.variantId) ?? findBestMatch(exchangeVariants, orderItem.variantInfo) ?? exchangeVariants[0];
    const exchangeTo = {
      ...event,
      exchangeForCredit: true
    };
    onChange === null || onChange === void 0 ? void 0 : onChange({
      type: 'exchangeForCredit',
      exchangeTo,
      variantInfo: exchangeTo.variantInfo
    });
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(exchangeTo);
  };
  const handleSubmit = () => {
    if (exactMatch && exactMatch.available) {
      const event = exactMatch;
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, upsell ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsExchangeUpsellTitle",
    defaultString: returnsReasonsExchangeUpsellTitle
  }) : /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsExchangeTitle",
    defaultString: returnsReasonsExchangeTitle
  })), !unavailable && swatches.map(opt => {
    var _exchangeSelections$o;
    return /*#__PURE__*/React__default["default"].createElement(SwatchesList["default"], {
      key: opt.id,
      type: opt.displayType,
      label: opt.name,
      options: opt.options,
      value: exchangeSelections === null || exchangeSelections === void 0 ? void 0 : (_exchangeSelections$o = exchangeSelections[opt.id]) === null || _exchangeSelections$o === void 0 ? void 0 : _exchangeSelections$o.value,
      onChange: handleChangeFactory(opt)
    });
  }), unavailable && /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsExchangeUnavailable"
  })), !upsell && shopNow && /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: null
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: ReturnReasonsExchange_module["default"].shopNowWrapper
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsShopNowDescription"
  }), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    onClick: handleShopNow
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsShopNowLink"
  })))), hideSubmit || unavailable ? null : noThanks ? /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    onClick: onSkip
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsExchangeUpsellNoThanks",
    defaultString: returnsReasonsExchangeUpsellNoThanks
  })) : /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    onClick: handleSubmit,
    disabled: !(exactMatch !== null && exactMatch !== void 0 && exactMatch.available)
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsActionsNext",
    defaultString: returnsActionsNext
  })), loading && /*#__PURE__*/React__default["default"].createElement(Spinner["default"], null));
};

exports["default"] = ReturnReasonsExchange;
